export default __webpack_public_path__ + "static/media/technical_interview.3053c4e6.png";